import React from 'react';
import { Link } from 'react-router-dom';
import { profile, sections } from '../data/profile';
export function SiteFooter() {
  return <footer className="bg-navy text-paper" data-id="element-118" data-mp="3r8rhssftkdzf">
      <div className="mx-auto grid max-w-shell gap-10 px-6 py-14 lg:grid-cols-12 lg:gap-16 lg:px-10" data-id="element-119" data-mp="3mh9i07pj8jg1">
        <div className="lg:col-span-5" data-id="element-120" data-mp="3hips5w7tinie">
          <p className="font-display text-2xl font-light leading-snug" data-id="element-121" data-mp="3hhoinw6ga92s">
            Open to board appointments, executive advisory, and C-suite leadership roles.
          </p>
          <a href={`mailto:${profile.email}`} className="mt-5 inline-block text-[14px] text-gold-soft underline decoration-gold-soft/40 underline-offset-4 transition-colors duration-150 ease-out hover:decoration-gold-soft" data-id="element-122" data-mp="38hi74fubbj69">
            {profile.email}
          </a>
        </div>

        <nav aria-label="All sections" className="lg:col-span-7" data-id="element-123" data-mp="11q0mw436amlk">
          <p className="text-[11px] uppercase tracking-overline text-white/45" data-id="element-124" data-mp="wsh0ggwbn3ij">Sections</p>
          <ul className="mt-5 grid grid-cols-1 gap-x-8 gap-y-2.5 sm:grid-cols-2" data-id="element-125" data-mp="15r504t1xn0nj">
            {sections.map(s => <li key={s.path} data-id="element-126" data-mp="1aq874j1h3gy5">
                <Link to={s.path} className="flex items-baseline gap-3 text-[14px] text-white/70 transition-colors duration-150 ease-out hover:text-paper" data-id="element-127" data-mp="1arj86b3jaalk">
                  <span className="font-display text-[11px] text-gold-soft/60" data-id="element-128" data-mp="10s0rc3ix74xq">{s.number}</span>
                  {s.title}
                </Link>
              </li>)}
          </ul>
        </nav>
      </div>

      <div className="border-t border-white/10" data-id="element-129" data-mp="1tiadn1kehguo">
        <div className="mx-auto flex max-w-shell flex-col gap-3 px-6 py-5 text-[12px] text-white/45 sm:flex-row sm:items-center sm:justify-between lg:px-10" data-id="element-130" data-mp="1eqidhwt6g9dj">
          <p data-id="element-131" data-mp="27g7g2eljchh9">© {new Date().getFullYear()} Keith Kohl. All rights reserved.</p>
          <Link to="/contact" className="transition-colors duration-150 ease-out hover:text-white/80" data-id="element-132" data-mp="27e4fj0mrb5ya">
            Privacy Policy
          </Link>
        </div>
      </div>
    </footer>;
}